const ReviewsAPI = [
  {
    id: 0,
    review: `Stephanie is able to tap into what my energy needs, what I am feeling and even can identify parts of my body that need attention. Booking with Stephanie is a massage and a spiritual experience all in one. Book your session ASAP and you will not regret it!`,
    name: `Angela G`,
  },
  {
    id: 1,
    review: `I always look forward to my appointments with Stephanie each month. She is a true healer who is fully present, attentive, and warm. She always checks in before and after the session about how you're feeling, so you can be confident that if you come to her your specific needs will be heard and considered when developing a plan of care. Can't recommend her enough!`,
    name: `Rachel R `,
  },
  {
    id: 2,
    review: `I recommend Stephanie to EVERYONE. As a hairstylist for 10+ years my body has seen better days. Steph always approaches each visit with a consult, so I know treatment will always be geared to what is bothering me that day. She combines multiple techniques for the perfect experience. Steph has the most calming, healing energy and her space reflects that.`,
    name: `Stephanie C `,
  },
  {
    id: 3,
    review: `Stephanie enabled me to experience such deep rest and relaxation. I had torn my meniscus and recently had intestinal polyps removed. So we worked together on Reiki and craniosacral therapy to calm and shift into my parasympathetic state. I felt so safe, supported and she has the most lovely demeanor and energy. She was so grounding, calm and highly talented.`,
    name: `Catriona P `,
  },
  {
    id: 4,
    review: `Stephanie is so talented and in tune with her clients needs. She tailors each and every treatment based on what you need that day. It is one of my very favorite methods of self care. I look forward to my next visit!`,
    name: `Meredith G `,
  },
  {
    id: 5,
    review: `Absolutely amazing! She remembered some previous issues I had and asked if she should work on the same areas. She is truly one of a kind and her new space is even more calming and peaceful than the previous one`,
    name: `Amy G `,
  },
  {
    id: 6,
    review: `I'm really grateful to have found Stephanie. My TMJD and related neck and shoulder tension has become distracting and painful. She is thoughtful, attentive to my concerns and is going above and beyond to help me address it. My body felt great after our first session and I am optimistic about what I will learn from her to help take care of myself`,
    name: `Verified anonymous `,
  },
  {
    id: 7,
    review: `Stephanie is amazing! She always is able to read my body in the moment and her ability to respond precisely and helpfully is wonderful. Thank you!`,
    name: `Verified anonymous `,
  },
  {
    id: 8,
    review: `Stephanie is amazing. She is the most skilled massage professional I have ever encountered. Every time she successfully addresses the challenges I have. She helped me heal from major orthopedic surgery and has also helped with so many other areas.`,
    name: `Tracy N `,
  },
  {
    id: 9,
    review: `Stephanie is wonderful!! Before the massage, my entire body felt like a giant knot. Stephanie designed a thoughtful and unique massage experience with cupping, aromatherapy, and even a massage gun! I cannot recommend her enough. On top of being a smart and capable therapist, Stephanie is also a joy to be around because of her positive personality. :)`,
    name: `Alex W `,
  },
  {
    id: 10,
    review: `Stephanie is brilliant at what she does. I've been seeing her for 3 years and every visit is perfectly therapeutic, healing, and comfortable. She always listens and customizes each session to ensure all my needs are met. I cannot recommend her enough. She is amazing!`,
    name: `Emily K`,
  },
  {
    id: 11,
    review: `A bodywork session with Stephanie surpasses most of the massages I have had in my life! Her treatment style is unique and strategic, it always leaves me feeling well aligned and totally at-ease. I started seeing Stephanie at the recommendation of a friend and love how she combines cupping, stretching, and traditional massage.`,
    name: `Gianna B `,
  },
];

export default ReviewsAPI;
